import { useState, useEffect } from 'react';
import { stringifyUrl } from 'query-string';
import { MailStatus } from '../components/MailStatus';

export interface MailStatusResponse {
    mailExists: boolean,
    mailWorking: boolean,
    smtpEnabled: boolean,
}

export class MailClient {
    private baseUrl: string;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ? baseUrl : "/wp-json/bda-cli/v2/";
    }

    async getMailStatus(mailTo: string): Promise<MailStatusResponse> {
        const setupQuery = [
            { key: "to", value: mailTo }
        ];

        const query = setupQuery.reduce((acc, cur) =>
            (cur.value === null || cur.value === undefined || cur.value === "" ? acc : { ...acc, [cur.key]: cur.value }), {});

        let path = this.baseUrl + "get-mail-status";

        const url = stringifyUrl({ url: path, query: query });

        return await fetch(url)
            .then(r => r.json())
            .then((data: MailStatusResponse) => {
                const result: MailStatusResponse = {
                    mailExists: data.mailExists,
                    mailWorking: data.mailWorking,
                    smtpEnabled: data.smtpEnabled,
                };

                return result;
            });
    }
}